<template>
    <div class="index">
        <div class="dealer">
            <ul class="flex f-wrap f-between">
                <li class="list" v-for="(item,index) in dealerData">
                    <p class="f24 fw-b col666">{{item.title}}</p>
                    <span>{{item.num}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                dealerData: [
                    {
                        title: '经销商',
                        num: '0个'
                    }, {
                        title: '集团客户',
                        num: '0个'
                    }, {
                        title: '门店客户',
                        num: '0家'
                    }, {
                        title: '总屏幕',
                        num: '0个'
                    }, {
                        title: '已分配屏幕',
                        num: '0个'
                    }, {
                        title: '未分配屏幕',
                        num: '0个'
                    }
                ],
            }
        },
        created() {
            var that = this;

            that.getscreeninfo();
        },
        methods: {
            getscreeninfo() {
                var that = this;

                var req = {};

                if(that.accountutil.isGroup()){
                    req.businessid = that.accountutil.getBid();
                    req.businesstype = 300;
                }else{
                    req.businessid = that.accountutil.getAgent().agentid;
                    req.businesstype = 200
    
                }

                that.httputil.post({
                    that: that,
                    url: that.api.getscreeninfo,
                    req: req,
                    xmsuccess: function (res) {
                        that.dealerData = [];

                        if(!that.accountutil.isGroup()){
                            that.dealerData.push({
                                title: '经销商',
                                num: parseInt(res.dealersnum || "0") + '个'
                            });

                            that.dealerData.push({
                                title: '集团客户',
                                num: parseInt(res.brandnum || "0") + '个'
                            });
                        }

                        that.dealerData.push({
                            title: '门店客户',
                            num: parseInt(res.storenum || "0") + '家'
                        });

                        that.dealerData.push({
                            title: '总屏幕',
                            num: parseInt(res.totalpropsnum || "0") + '个'
                        });

                        that.dealerData.push({
                            title: '已分配屏幕',
                            num: parseInt(res.rolloutpropsnum || "0") + '个'
                        });

                        that.dealerData.push({
                            title: '未分配屏幕',
                            num: parseInt(res.ownerpropsnum || "0") + '个'
                        });
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .dealer {
        margin-top: 120px;
    }
    .dealer ul{
        padding:0 70px;
    }
    .list {
        width: 26%;
        height: 180px;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
        text-align: center;
        margin-bottom: 60px;
        padding-top: 60px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/index.vue